import type {
  AssetTypeTemplatesTableColumn,
  AssetTypeTemplatesTableProps,
} from "./asset-type-templates-table.type";
import type { EntityTemplateLite } from "@/entities/entity-template";

import { useTranslation } from "react-i18next";

import TableTitleCell from "@/components/Elements/TableTitleCell";
import ListTable from "@/modules/list-table";
import { ModelLink } from "@/modules/model-link";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";

const AssetTypeTemplatesTable = (
  listTableProps: AssetTypeTemplatesTableProps
) => {
  const { t } = useTranslation();
  const columns: AssetTypeTemplatesTableColumn[] = [
    {
      title: t("global:name"),
      dataIndex: "name",
      render: (_, technicalform: EntityTemplateLite) => (
        <TableTitleCell tooltip={technicalform.name}>
          <ModelLink model="technicalform" item={technicalform} />
        </TableTitleCell>
      ),
      sorter: true,
      ...TABLE_FILTER_TEXT,
    },
    {
      title: t("global:assetTypePlural"),
      dataIndex: "asset_types_count",
      sorter: true,
      width: "10%",
      minWidth: 120,
    },
  ];

  return <ListTable columns={columns} {...listTableProps} />;
};

export default AssetTypeTemplatesTable;
